/* tslint:disable */
import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpRequest,
  HttpResponse,
  HttpHeaders,
} from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ClusterTfVersionMapping } from '../models/cluster-tf-version-mapping';
import { TfVersion } from '../models/tf-version';
import { PendingMigrationDetails } from '../models/pending-migration-details';

/**
 * Ui Tf Version Controller
 */
@Injectable({
  providedIn: 'root',
})
class UiTfVersionControllerService extends __BaseService {
  static readonly getTfStreamForClusterUsingGETPath =
    '/cc-ui/v1/terraform/cluster/{clusterId}';
  static readonly setTfVersionForClusterUsingPUTPath =
    '/cc-ui/v1/terraform/cluster/{clusterId}';
  static readonly deleteTfStreamForClusterUsingDELETEPath =
    '/cc-ui/v1/terraform/cluster/{clusterId}';
  static readonly getPendingMigrationScriptsByClusterIdUsingGETPath =
    '/cc-ui/v1/terraform/cluster/{clusterId}/pending-migration-scripts';
  static readonly getTfVersionsForStreamUsingGETPath =
    '/cc-ui/v1/terraform/stream/{tfStream}/versions';
  static readonly populateReleaseStreamTfVersionMappingUsingPOSTPath =
    '/cc-ui/v1/terraform/sync-release-stream-mapping';
  static readonly getAllVersionsUsingGETPath = '/cc-ui/v1/terraform/versions';

  constructor(config: __Configuration, http: HttpClient) {
    super(config, http);
  }

  /**
   * getTfStreamForCluster
   * @param clusterId clusterId
   * @return OK
   */
  getTfStreamForClusterUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<ClusterTfVersionMapping>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/terraform/cluster/${encodeURIComponent(String(clusterId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ClusterTfVersionMapping>;
      }),
    );
  }
  /**
   * getTfStreamForCluster
   * @param clusterId clusterId
   * @return OK
   */
  getTfStreamForClusterUsingGET(
    clusterId: string,
  ): __Observable<ClusterTfVersionMapping> {
    return this.getTfStreamForClusterUsingGETResponse(clusterId).pipe(
      __map((_r) => _r.body as ClusterTfVersionMapping),
    );
  }

  /**
   * setTfVersionForCluster
   * @param params The `UiTfVersionControllerService.SetTfVersionForClusterUsingPUTParams` containing the following parameters:
   *
   * - `tfVersion`: tfVersion
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  setTfVersionForClusterUsingPUTResponse(
    params: UiTfVersionControllerService.SetTfVersionForClusterUsingPUTParams,
  ): __Observable<__StrictHttpResponse<ClusterTfVersionMapping>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = params.tfVersion;

    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl +
        `/cc-ui/v1/terraform/cluster/${encodeURIComponent(
          String(params.clusterId),
        )}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ClusterTfVersionMapping>;
      }),
    );
  }
  /**
   * setTfVersionForCluster
   * @param params The `UiTfVersionControllerService.SetTfVersionForClusterUsingPUTParams` containing the following parameters:
   *
   * - `tfVersion`: tfVersion
   *
   * - `clusterId`: clusterId
   *
   * @return OK
   */
  setTfVersionForClusterUsingPUT(
    params: UiTfVersionControllerService.SetTfVersionForClusterUsingPUTParams,
  ): __Observable<ClusterTfVersionMapping> {
    return this.setTfVersionForClusterUsingPUTResponse(params).pipe(
      __map((_r) => _r.body as ClusterTfVersionMapping),
    );
  }

  /**
   * deleteTfStreamForCluster
   * @param clusterId clusterId
   * @return OK
   */
  deleteTfStreamForClusterUsingDELETEResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<boolean>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl +
        `/cc-ui/v1/terraform/cluster/${encodeURIComponent(String(clusterId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'text',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return (_r as HttpResponse<any>).clone({
          body: (_r as HttpResponse<any>).body === 'true',
        }) as __StrictHttpResponse<boolean>;
      }),
    );
  }
  /**
   * deleteTfStreamForCluster
   * @param clusterId clusterId
   * @return OK
   */
  deleteTfStreamForClusterUsingDELETE(
    clusterId: string,
  ): __Observable<boolean> {
    return this.deleteTfStreamForClusterUsingDELETEResponse(clusterId).pipe(
      __map((_r) => _r.body as boolean),
    );
  }

  /**
   * getPendingMigrationScriptsByClusterId
   * @param clusterId clusterId
   * @return OK
   */
  getPendingMigrationScriptsByClusterIdUsingGETResponse(
    clusterId: string,
  ): __Observable<__StrictHttpResponse<PendingMigrationDetails>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/terraform/cluster/${encodeURIComponent(
          String(clusterId),
        )}/pending-migration-scripts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<PendingMigrationDetails>;
      }),
    );
  }
  /**
   * getPendingMigrationScriptsByClusterId
   * @param clusterId clusterId
   * @return OK
   */
  getPendingMigrationScriptsByClusterIdUsingGET(
    clusterId: string,
  ): __Observable<PendingMigrationDetails> {
    return this.getPendingMigrationScriptsByClusterIdUsingGETResponse(
      clusterId,
    ).pipe(__map((_r) => _r.body as PendingMigrationDetails));
  }

  /**
   * getTfVersionsForStream
   * @param tfStream tfStream
   * @return OK
   */
  getTfVersionsForStreamUsingGETResponse(
    tfStream: string,
  ): __Observable<__StrictHttpResponse<Array<TfVersion>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl +
        `/cc-ui/v1/terraform/stream/${encodeURIComponent(
          String(tfStream),
        )}/versions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TfVersion>>;
      }),
    );
  }
  /**
   * getTfVersionsForStream
   * @param tfStream tfStream
   * @return OK
   */
  getTfVersionsForStreamUsingGET(
    tfStream: string,
  ): __Observable<Array<TfVersion>> {
    return this.getTfVersionsForStreamUsingGETResponse(tfStream).pipe(
      __map((_r) => _r.body as Array<TfVersion>),
    );
  }

  /**
   * populateReleaseStreamTfVersionMapping
   */
  populateReleaseStreamTfVersionMappingUsingPOSTResponse(): __Observable<
    __StrictHttpResponse<null>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/cc-ui/v1/terraform/sync-release-stream-mapping`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      }),
    );
  }
  /**
   * populateReleaseStreamTfVersionMapping
   */
  populateReleaseStreamTfVersionMappingUsingPOST(): __Observable<null> {
    return this.populateReleaseStreamTfVersionMappingUsingPOSTResponse().pipe(
      __map((_r) => _r.body as null),
    );
  }

  /**
   * getAllVersions
   * @return OK
   */
  getAllVersionsUsingGETResponse(): __Observable<
    __StrictHttpResponse<Array<TfVersion>>
  > {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/cc-ui/v1/terraform/versions`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json',
      },
    );

    return this.http.request<any>(req).pipe(
      __filter((_r) => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<TfVersion>>;
      }),
    );
  }
  /**
   * getAllVersions
   * @return OK
   */
  getAllVersionsUsingGET(): __Observable<Array<TfVersion>> {
    return this.getAllVersionsUsingGETResponse().pipe(
      __map((_r) => _r.body as Array<TfVersion>),
    );
  }
}

module UiTfVersionControllerService {
  /**
   * Parameters for setTfVersionForClusterUsingPUT
   */
  export interface SetTfVersionForClusterUsingPUTParams {
    /**
     * tfVersion
     */
    tfVersion: TfVersion;

    /**
     * clusterId
     */
    clusterId: string;
  }
}

export { UiTfVersionControllerService };
